<template>
  <div ref="rootEl" class="mutil-result">
    <div class="rate-wrap">
      <RateCount :num="maxNum" />
    </div>
    <div class="list">
      <transition-group tag="div" name="__ck-mutil-list-transition__">
        <MutilResultItem v-for="(item, index) in result" :key="index + '_' + item.id" :cardResult="item"
      /></transition-group>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";

import RateCount from "./RateCount.vue";
import MutilResultItem from "./MutilResultItem.vue";

export default {
  name: "MutilResult",
  components: { RateCount, MutilResultItem },
  props: {
    cardResult: { type: Array, required: true },
    maxNum: { type: Number, default: 0 },
    assetCount: { type: Number, default: 0 }
  },
  data() {
    return {
      result: []
    };
  },
  watch: {
    cardResult: {
      immediate: true,
      handler(array) {
        if (array.length > 0) {
          const vm = this;
          this.result = [];
          let clone = JSON.parse(JSON.stringify(array));

          const emptyClone = () => {
            vm.result.push(...clone);
            clone = [];
            vm.$parent.actionVisible = true;
            vm.$parent.tooltipVisible = true;
          };

          document.addEventListener("click", emptyClone, { once: true, capture: true });

          const pick = () => {
            if (clone.length === 0) {
              document.removeEventListener("click", emptyClone);
              return;
            }
            const el = clone.shift();
            vm.result.push(el);
            setTimeout(pick, 100);
          };
          setTimeout(pick, 100);
          // this.result = array;
        }
      }
    }
  },
  methods: {
    exposeGenerateCanvas() {
      const vm = this;
      return new Promise((resolve, reject) => {
        /** @type {HTMLDivElement} */
        const rootEl = vm.$refs.rootEl;
        html2canvas(rootEl, {
          backgroundColor: null,
          useCORS: true,
          allowTaint: true,
          scale: 1
        })
          .then(canvas => {
            resolve(canvas.toDataURL("image/png", 1.0));
          })
          .catch(reject);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.mutil-result {
  height: 100%;
  transform: translateZ(1px);
  position: relative;
  background: url("~@/assets/zs_imgs/ck-mutil-bg.png") center / cover no-repeat;
  .rate-wrap {
    position: absolute;
    left: 48px;
    bottom: 26px;
  }
  .list {
    height: 100%;
    & > div {
      display: grid;
      grid-template-columns: repeat(10, 53px);
      height: 100%;
      justify-content: center;
      column-gap: 16px;
      padding-bottom: 32px;
    }
  }
}
</style>
<style>
.__ck-mutil-list-transition__-enter-active,
.__ck-mutil-list-transition__-leave-active {
  transition: all 200ms;
}
.__ck-mutil-list-transition__-enter, .__ck-mutil-list-transition__-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(50px);
}
</style>
